export default {
  TableHead: [
    [
      {
        displayName: 'message.datatable.number',
      },
      {
        displayName: 'message.datatable.discription',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'message.datatable.type',
      },
      {
        displayName: 'message.datatable.status',
      },
      {
        displayName: 'message.datatable.createdate',
      },
      {
        displayName: 'message.datatable.manage',
      },
      {
        displayName: 'message.datatable.delete',
      },
    ],
  ],
  initialModel() {
    return {
      type: 'agent',
      content: '',
      isActive: true,
    };
  },
};
